module.exports = __webpack_public_path__ + "static/media/01_a.4305ade8.png";